import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { WindowCloseDirective } from '../../utility/window-close.directive';
import { LeftMainData } from './left-main-data';
import { CommonFileData } from '../../data/common-file-data';
import { CommonConst } from '../../const/common-const';
import { FileUtil } from '../../utility/file-util';
import { MessageUtil } from '../../utility/message-util';
import { ValidationUtil } from '../../utility/validation-util';
import { Router } from '@angular/router';
import { DialogService } from 'ngx-bootstrap-modal';
import { DialogYesComponent } from '../dialog-yes';
import { CommonStorageKey } from '../../const/common-storage-key';
import { RedirectUtil } from '../../utility/redirect-util';
import { GaUtil } from '../../utility/ga-util';

@Component({
  selector: 'app-left',
  templateUrl: './left.component.html'
})
export class LeftComponent{

  isExpanded = false;
  n201Flg = false;
  n202Flg = false;
  n203Flg = false;
  n205Flg = false;
  n206Flg = false;
  n207Flg = false;

  n301Flg = false;
  n302Flg = false;
  n303Flg = false;
  n306Flg = false;
  n307Flg = false;

  n402Flg = false;
  n403Flg = false;
  n404Flg = false;
  n407Flg = false;
  n408Flg = false;
  n409Flg = false;

  n50212Flg = false;
  n503Flg = false;
  
  public leftMainData: LeftMainData;
  public fileData = new CommonFileData();
  // ST-412 start
  public kinouIdMap = new Map([
    [CommonConst.PGM_N5031, 'お問い合わせ'],
    [CommonConst.PGM_N2011, '商品・在庫照会'],
    [CommonConst.PGM_N2021, '発注入力'],
    [CommonConst.PGM_N2031, '発注状況照会'],
    [CommonConst.PGM_N2051, 'お買い上げ明細照会'],
    [CommonConst.PGM_N2061, '出荷明細書一括ダウンロード'],
    [CommonConst.PGM_N2071, '出荷明細データ２ダウンロード'],
    [CommonConst.PGM_N3011, '配送情報参照'],
    [CommonConst.PGM_N3021, '配送時間個別仮登録'],
    [CommonConst.PGM_N3023, '配送時間一括仮登録'],
    [CommonConst.PGM_N3031, '配送時間本登録'],
    [CommonConst.PGM_N3061, '返品引取情報参照'],
    [CommonConst.PGM_N3071, 'パレット回収情報参照'],  
    [CommonConst.PGM_N4021, 'ユーザ登録依頼一覧'],
    [CommonConst.PGM_N4031, 'ユーザ登録'],
    [CommonConst.PGM_N4041, 'ユーザ管理一覧'],
    [CommonConst.PGM_N4071, 'お知らせ管理'],
    [CommonConst.PGM_N4081, '代行ユーザ一覧'],
    [CommonConst.PGM_N4091, '方面登録'],
    [CommonConst.PGM_N50212, '商品マスタダウンロード']]);
  // ST-412 end
  constructor(private http: HttpClient,
    private dialogService: DialogService,
    private router: Router) {
    this.leftMainData = new LeftMainData();
    
  }

  //画面初期化イベント
  ngOnInit() {
    let heightLeftMenu: number = document.getElementById("left_menu").clientHeight;
    sessionStorage.setItem(CommonStorageKey.LEFTMENUHEIGHT, '' + heightLeftMenu);

    // グループ区分毎の権限設定
    if (sessionStorage.getItem(CommonStorageKey.GURUPUKUBUN) == CommonConst.C_GURUPU_KUBUN_ICHIJITEN) {
      // 一次店
      this.n201Flg = true;
      this.n202Flg = true;
      this.n203Flg = true;
      this.n205Flg = true;
      this.n206Flg = true;
      this.n207Flg = true;

      this.n503Flg = true;
      this.n50212Flg = true;

    } else if (sessionStorage.getItem(CommonStorageKey.GURUPUKUBUN) == CommonConst.C_GURUPU_KUBUN_NIJITEN) {
      // 二次店
      this.n201Flg = true;
      this.n202Flg = true;
      this.n203Flg = true;
      this.n205Flg = true;

      this.n503Flg = true;
      this.n50212Flg = true;

    } else if (sessionStorage.getItem(CommonStorageKey.GURUPUKUBUN) == CommonConst.C_GURUPU_KUBUN_BUTSURYU_GAISHA) {
      // 物流会社
      this.n301Flg = true;
      this.n302Flg = true;
      this.n303Flg = true;
      this.n306Flg = true;
      this.n307Flg = true;

      this.n409Flg = true;
      this.n503Flg = true; // ST-285

    } else if (sessionStorage.getItem(CommonStorageKey.GURUPUKUBUN) == CommonConst.C_GURUPU_KUBUN_EIGYOSHO) {
      // 営業所
      this.n201Flg = true;
      this.n203Flg = true;
      this.n205Flg = true;
      this.n206Flg = true;

      this.n301Flg = true;

      this.n402Flg = true;

      this.n50212Flg = true;

    } else if (sessionStorage.getItem(CommonStorageKey.GURUPUKUBUN) == CommonConst.C_GURUPU_KUBUN_BUTSURYU_CENTER) {
      // 物流センター
      this.n301Flg = true;
      this.n302Flg = true;
      this.n303Flg = true;
      this.n306Flg = true;
      this.n307Flg = true;

      this.n409Flg = true;

    } else if (sessionStorage.getItem(CommonStorageKey.GURUPUKUBUN) == CommonConst.C_GURUPU_KUBUN_JUCHU_CENTER) {
      // 受注センター
      this.n201Flg = true;
      this.n203Flg = true;
      this.n205Flg = true;
      this.n206Flg = true;

      this.n301Flg = true;

      this.n50212Flg = true;

    } else if (sessionStorage.getItem(CommonStorageKey.GURUPUKUBUN) == CommonConst.C_GURUPU_KUBUN_EIGYOKIKAKUBU) {
      // 営業企画部
      this.n201Flg = true;
      this.n203Flg = true;
      this.n205Flg = true;
      this.n206Flg = true;

      this.n301Flg = true;

      this.n407Flg = true;

      this.n50212Flg = true;

    } else if (sessionStorage.getItem(CommonStorageKey.GURUPUKUBUN) == CommonConst.C_GURUPU_KUBUN_BUTSURYUBU) {
      // 物流部
      this.n201Flg = true;

      this.n301Flg = true;

      this.n402Flg = true;

      this.n50212Flg = true;

    } else if (sessionStorage.getItem(CommonStorageKey.GURUPUKUBUN) == CommonConst.C_GURUPU_KUBUN_SYSTEM_KANRISHA) {
      // システム管理者
      this.n201Flg = true;

      this.n402Flg = true;
      // 強化テストNo.105 delete
      this.n408Flg = true;
      this.n404Flg = true;
      this.n407Flg = true;

      this.n50212Flg = true;

    } else {
    }

    // ロールの設定
    if (sessionStorage.getItem(CommonStorageKey.RORUID) !== null) {
      let kengenList: Array<string> = sessionStorage.getItem(CommonStorageKey.KENGENLIST).split(",");
      // グループ区分による権限設定で表示対象のメニューのみ判定する
      if (this.n201Flg) this.n201Flg = kengenList[0] == "1" ? true : false;
      if (this.n202Flg) this.n202Flg = kengenList[1] == "1" ? true : false;
      if (this.n203Flg) this.n203Flg = kengenList[2] == "1" ? true : false;
      if (this.n205Flg) this.n205Flg = kengenList[3] == "1" ? true : false;
      if (this.n206Flg) this.n206Flg = kengenList[4] == "1" ? true : false;
      if (this.n207Flg) this.n207Flg = kengenList[5] == "1" ? true : false;
      if (this.n306Flg) this.n306Flg = kengenList[6] == "1" ? true : false;
      if (this.n307Flg) this.n307Flg = kengenList[7] == "1" ? true : false;
      if (this.n301Flg) this.n301Flg = kengenList[8] == "1" ? true : false;
      if (this.n302Flg) this.n302Flg = kengenList[9] == "1" ? true : false;
      if (this.n302Flg) this.n302Flg = kengenList[10] == "1" ? true : false;
      if (this.n303Flg) this.n303Flg = kengenList[11] == "1" ? true : false;
      if (this.n503Flg) this.n503Flg = kengenList[12] == "1" ? true : false;
      if (this.n50212Flg) this.n50212Flg = kengenList[13] == "1" ? true : false;
      if (this.n402Flg) this.n402Flg = kengenList[14] == "1" ? true : false;
      if (this.n408Flg) this.n408Flg = kengenList[15] == "1" ? true : false;
      if (this.n404Flg) this.n404Flg = kengenList[16] == "1" ? true : false;
      if (this.n403Flg) this.n403Flg = kengenList[17] == "1" ? true : false;
      if (this.n407Flg) this.n407Flg = kengenList[18] == "1" ? true : false;
      if (this.n409Flg) this.n409Flg = kengenList[19] == "1" ? true : false;
    }
  }

  collapse(pgmId: string) {
    this.isExpanded = false;
    // ST-158(業務時間外メッセージの整理対応) ADD START
    document.body.style.cursor = 'wait';
    this.leftMainData.uniqueId = sessionStorage.getItem(CommonStorageKey.UNIQUEID);
    this.leftMainData.pgmId = pgmId;
    this.leftMainData.daikouFlg = sessionStorage.getItem(CommonStorageKey.DAIKOUFLG); // ST-162
    this.http.post<LeftMainData>('/KadouCheck', this.leftMainData).subscribe(result => {
      // 非稼働の場合、画面上部にエラーメッセージを表示する
      if (result[0].rtnCode == CommonConst.C_RTN_CODE_HIKADOU) {
        this.dialogService.addDialog(DialogYesComponent, { message: MessageUtil.getStorageMessage('N000023', [this.kinouIdMap.get(pgmId)]) } // ST-412
        ).subscribe((isOk) => { });
        return;
      }
      // それ以外のエラーは適切な共通エラー画面へ遷移する
      if (RedirectUtil.toMaintenance(result, this.router)) {
        return;
      }
      this.leftMainData = result[0];
      if (this.leftMainData.rtnCode == CommonConst.C_RTN_CODE_OK) {
        // 正常ならば、選択されたメニューの画面へ遷移する
        switch (pgmId) {
          case CommonConst.PGM_N5021:
            this.router.navigateByUrl('/n5021');
            break;
          case CommonConst.PGM_N2011:
            this.router.navigateByUrl('/n2011');
            break;
          case CommonConst.PGM_N2021:
            this.router.navigateByUrl('/n2021');
            break;
          case CommonConst.PGM_N2031:
            this.router.navigateByUrl('/n2031');
            break;
          case CommonConst.PGM_N2051:
            this.router.navigateByUrl('/n2051');
            break;
          case CommonConst.PGM_N2061:
            this.router.navigateByUrl('/n2061');
            break;
          case CommonConst.PGM_N2071:
            this.router.navigateByUrl('/n2071');
            break;
          case CommonConst.PGM_N3011:
            this.router.navigateByUrl('/n3011');
            break;
          case CommonConst.PGM_N3021:
            this.router.navigateByUrl('/n3021');
            break;
          case CommonConst.PGM_N3023:
            this.router.navigateByUrl('/n3023');
            break;
          case CommonConst.PGM_N3031:
            this.router.navigateByUrl('/n3031');
            break;
          case CommonConst.PGM_N3061:
            this.router.navigateByUrl('/n3061');
            break;
          case CommonConst.PGM_N3071:
            this.router.navigateByUrl('/n3071');
            break;
          case CommonConst.PGM_N4021:
            this.router.navigateByUrl('/n4021');
            break;
          case CommonConst.PGM_N4031:
            this.router.navigateByUrl('/n4031');
            break;
          case CommonConst.PGM_N4041:
            this.router.navigateByUrl('/n4041');
            break;
          case CommonConst.PGM_N4071:
            this.router.navigateByUrl('/n4071');
            break;
          case CommonConst.PGM_N4081:
            this.router.navigateByUrl('/n4081');
            break;
          case CommonConst.PGM_N4091:
            this.router.navigateByUrl('/n4091');
            break;
          case CommonConst.PGM_N50212:
            this.shohiMmasutaPrint();
            break;
          case CommonConst.PGM_N5031:
            this.router.navigateByUrl('/n5031');
            break;
          default:
            this.router.navigateByUrl('/ne01', { skipLocationChange: true });
            break;
        }
      } else {
        this.router.navigateByUrl('/ne01', { skipLocationChange: true });
      }

    }, error => this.router.navigateByUrl('/ne01', { skipLocationChange: true }), () => { document.body.style.cursor = 'default'; });
    GaUtil.traceEvent_EachGroupCd('メニュー 選択', '');
    // ST-158(業務時間外メッセージの整理対応) ADD END
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  @HostListener('window:unload') unloadHandler() {
    // 移転の場合、子画面を閉じない。
    if (WindowCloseDirective.itenFlg) {
      WindowCloseDirective.itenFlg = false;
      return;
    }
    // 親画面を閉じる場合、子画面も閉じる。
    if (WindowCloseDirective.winList !== null && WindowCloseDirective.winList.length > 0) {
      for (let i = 0; i < WindowCloseDirective.winList.length; i++) {
        const winItem = WindowCloseDirective.winList[i];
        if (!winItem.closed) {
          winItem.close();
        }
      }
    }
  }

  shohiMmasutaPrint() {
    document.body.style.cursor = 'wait';
    this.fileData.uniqueId = sessionStorage.getItem(CommonStorageKey.UNIQUEID);
    this.http.post<CommonFileData>('/PrintN50212', this.fileData).subscribe(result => {
      // 非稼働の場合、メンテナンス画面に遷移する
      if (RedirectUtil.toMaintenance(result, this.router)) {
        return;
      }
      this.fileData = result[0];
      if (this.fileData.rtnCode == CommonConst.C_RTN_CODE_OK) {
        let fileName = this.fileData.fileName;
        FileUtil.fileDownload(this.http, fileName, "1", this.fileData.downLoadFileName); // ST-361
      } else if (this.fileData.rtnCode == CommonConst.C_RTN_CODE_NG) {
        this.dialogService.addDialog(DialogYesComponent, { message: MessageUtil.getStorageMessage('N000013') }
        ).subscribe((isOk) => {
        });
      } else if (this.fileData.rtnCode == CommonConst.C_RTN_CODE_SYSTEM_ERR) {
        this.router.navigateByUrl('/ne01', { skipLocationChange: true });
      } else {
        this.router.navigateByUrl('/ne01', { skipLocationChange: true });
      }

    }, error => this.router.navigateByUrl('/ne01', { skipLocationChange: true }), () => { document.body.style.cursor = 'default'; });
    GaUtil.traceEvent_EachGroupCd('メニュー 商品マスタダウンロード', '');
  }

}




// WEBPACK FOOTER //
// ./src/app/modules/shared/component/left/left.component.ts